import { IPart } from './part';

export type IBoard = {
  key: string,
  name: string,
  description: string,
  image: string,
  parts: IPart[]
};
